<script lang="ts">
	import { CrossIcon } from '../../../assets/icons/CrossIcon';
	import { TickIcon } from '../../../assets/icons/TickIcon';
	import { UploadIcon } from '../../../assets/icons/UploadIcon';
	import { Link } from '../../Link';
	import { Txt } from '../../Txt';
	import type { DropzoneFile } from '../types';

	interface Props {
		onRemoveFile?: ((name: string) => void) | undefined;
		files: DropzoneFile[];
		dataCy: string;
		class?: string;
	}

	let { files = $bindable([]), dataCy, onRemoveFile = undefined, ...rest }: Props = $props();

	const handleClickRemove = (name: string) => {
		if (onRemoveFile) {
			onRemoveFile(name);
		}
	};
</script>

<ol class={rest.class}>
	{#each files as file, index}
		<li
			class="border-gray-175 mt-3 flex justify-between border bg-gray-50 px-4 py-3"
			data-cy={`${dataCy}-file-${index}`}
		>
			<div class="flex min-w-[calc(100%-24px)] max-w-[calc(100%-24px)] items-center">
				<UploadIcon class="mr-2.5 h-5 w-5" />

				{#if file?.url}
					<Link href={file.url} target="_blank" class="max-w-[calc(100%-100px)]">
						<Txt
							variant="body3"
							title={file?.name}
							class="mr-2 overflow-hidden text-ellipsis whitespace-nowrap text-gray-500 underline"
						>
							{file?.name}
						</Txt>
					</Link>
				{:else}
					<Txt
						component="a"
						href={URL.createObjectURL(file as Blob)}
						target="_blank"
						rel="noopener noreferrer"
						variant="body3"
						title={file?.name}
						class="underline mr-2 max-w-[calc(100%-100px)] overflow-hidden text-ellipsis whitespace-nowrap text-gray-500"
					>
						{file?.name}
					</Txt>
				{/if}

				<TickIcon class="h-4 w-4" color="green-500" />
			</div>
			{#if onRemoveFile}
				<button
					type="button"
					onclick={() => handleClickRemove(file?.name)}
					data-cy={`${dataCy}-file-${index}-remove-button`}
				>
					<CrossIcon class="h-5 w-5" />
				</button>
			{/if}
		</li>
	{/each}
</ol>
